import React from 'react';

import { Image } from '@consumer-frontend/shared-ui';

import styles from './CnuMaintenancePage.module.scss';
import '@consumer-bootstrap/index.scss';

export type CnuMaintenancePageT = React.FC;

/**
 * Full-viewport maintenance page shown when the cnu_maintenance flag is on.
 *
 * Intentionally has no nav, footer, or data fetching. During a real outage the
 * backend is likely failing, so this page must render without depending on it.
 * Both apps serve the logo from the same public path.
 *
 * The support number is a plain anchor rather than the shared Link component
 * because Link wraps react-router and this page renders outside any Router.
 */
export const CnuMaintenancePage: CnuMaintenancePageT = () => (
  <main className={styles['cnu-maintenance-page']}>
    <Image
      alt="CashNetUSA"
      className={styles['cnu-maintenance-logo']}
      src="/assets/images/CNU_Logo.svg"
    />
    <h1 className={styles['cnu-maintenance-heading']}>
      We&apos;ll be back shortly!
    </h1>
    <p className={styles['cnu-maintenance-message']}>
      CashNetUSA is undergoing planned maintenance.
    </p>
    <p className={styles['cnu-maintenance-message']}>
      Have a question or need assistance with your loan?{' '}
      <a className={styles['cnu-maintenance-phone']} href="tel:8888019075">
        888.801.9075
      </a>
    </p>
  </main>
);
